export const Group = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="2"
            viewBox="0 0 10 2"
            fill="none"
            className=""
        >
            <g opacity="0.5">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 0C4.44772 0 4 0.447715 4 1C4 1.55228 4.44772 2 5 2C5.55228 2 6 1.55228 6 1C6 0.447715 5.55228 0 5 0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 0C8.44772 0 8 0.447715 8 1C8 1.55228 8.44772 2 9 2C9.55228 2 10 1.55228 10 1C10 0.447715 9.55228 0 9 0Z"
                    fill="black"
                />
            </g>
        </svg>
    )
}

export const Like = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="13"
            viewBox="0 0 15 13"
            fill="none"
            className='ml-4'
        >
            <path
                opacity="0.5"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0969 12.9938H7.36905C6.87359 12.9933 6.39859 12.7973 6.04847 12.4488L5.17017 11.5755C4.9924 11.4241 4.91497 11.1865 4.96971 10.9602C5.02445 10.734 5.20211 10.5573 5.42966 10.5029C5.65721 10.4485 5.89624 10.5255 6.04847 10.7022L6.92678 11.5755C7.04433 11.6914 7.20347 11.7561 7.36905 11.7551H12.0969C12.392 11.7629 12.6521 11.5638 12.7199 11.2782L13.7601 6.94282C13.8047 6.75571 13.7593 6.55864 13.6373 6.40945C13.5153 6.26025 13.3305 6.17586 13.1372 6.18103H8.48406C8.05295 6.1808 7.6526 5.95898 7.4256 5.59458C7.19859 5.23018 7.1772 4.77499 7.36905 4.39113L8.44668 2.2544C8.55588 2.03745 8.5454 1.77996 8.41893 1.57249C8.29247 1.36502 8.06773 1.23664 7.82377 1.23249L5.13279 5.24582C4.62307 6.00495 4.30863 6.87691 4.21711 7.78512L3.86205 11.3278C3.76573 12.2807 2.95661 13.0048 1.99332 13H1.86874C0.836661 13 0 12.1681 0 11.142V6.18722C0 5.16106 0.836661 4.3292 1.86874 4.3292C2.21276 4.3292 2.49165 4.60649 2.49165 4.94854C2.49165 5.29059 2.21276 5.56788 1.86874 5.56788C1.52471 5.56788 1.24582 5.84517 1.24582 6.18722V11.142C1.24582 11.484 1.52471 11.7613 1.86874 11.7613H1.98709C2.30819 11.7629 2.57789 11.5215 2.61 11.2039L2.96506 7.66125C3.07801 6.55424 3.46074 5.49131 4.08007 4.56455L6.77105 0.551216C7.00169 0.207505 7.38952 0.000766915 7.80508 1.90148e-06C8.48417 -0.000940396 9.11515 0.348397 9.47198 0.922866C9.8288 1.49734 9.86041 2.21471 9.55547 2.818L8.47783 4.95473H13.131C13.7022 4.95465 14.2422 5.21437 14.5967 5.65978C14.9512 6.10518 15.0813 6.68734 14.9499 7.2401L13.9096 11.5755C13.7059 12.4069 12.9576 12.9924 12.0969 12.9938Z"
                fill="#0F1E36"
            />
        </svg>
    )
}

export const ListeningIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M9.99901 19.9991C10.2735 20.0102 10.5412 19.9122 10.7436 19.7265C10.9461 19.5408 11.0669 19.2826 11.0796 19.0082V0.992058C11.0564 0.721406 10.9325 0.469312 10.7324 0.285617C10.5322 0.101923 10.2705 0 9.99884 0C9.72719 0 9.46544 0.101923 9.26532 0.285617C9.0652 0.469312 8.94129 0.721406 8.91808 0.992058V19.0082C8.93079 19.2827 9.05161 19.541 9.25415 19.7266C9.45669 19.9123 9.72447 20.0103 9.99901 19.9991ZM9.60802 0.992058C9.63072 0.905621 9.68142 0.82914 9.75219 0.774562C9.82296 0.719984 9.90981 0.690383 9.99918 0.690383C10.0886 0.690383 10.1754 0.719984 10.2462 0.774562C10.3169 0.82914 10.3676 0.905621 10.3904 0.992058V19.0082C10.3676 19.0946 10.3169 19.1711 10.2462 19.2257C10.1754 19.2803 10.0886 19.3099 9.99918 19.3099C9.90981 19.3099 9.82296 19.2803 9.75219 19.2257C9.68142 19.1711 9.63072 19.0946 9.60802 19.0082V0.992058ZM5.5398 17.8269C5.81445 17.8379 6.08226 17.7396 6.28468 17.5537C6.48711 17.3677 6.60768 17.1092 6.62004 16.8346V3.16564C6.60768 2.89105 6.48711 2.63252 6.28468 2.44657C6.08226 2.26062 5.81445 2.16238 5.5398 2.17332C5.26526 2.16228 4.99751 2.26034 4.79504 2.44608C4.59257 2.63181 4.47184 2.89013 4.45921 3.1646V16.8346C4.47157 17.1093 4.59219 17.3679 4.79469 17.5538C4.99719 17.7398 5.26509 17.838 5.5398 17.8269ZM5.1488 3.16564C5.16321 3.07497 5.21172 2.99324 5.2844 2.93716C5.35708 2.88108 5.44844 2.85489 5.5398 2.86394C5.63115 2.85489 5.72251 2.88108 5.79519 2.93716C5.86787 2.99324 5.91638 3.07497 5.93079 3.16564V16.8346C5.91638 16.9253 5.86787 17.007 5.79519 17.0631C5.72251 17.1192 5.63115 17.1454 5.5398 17.1363C5.44844 17.1454 5.35708 17.1192 5.2844 17.0631C5.21172 17.007 5.16321 16.9253 5.1488 16.8346V3.16564ZM14.4582 16.1644C14.7329 16.1754 15.0008 16.0772 15.2033 15.8912C15.4058 15.7053 15.5265 15.4467 15.5388 15.172V4.82823C15.5147 4.55834 15.3904 4.30726 15.1905 4.12439C14.9905 3.94152 14.7294 3.84011 14.4584 3.84011C14.1874 3.84011 13.9263 3.94152 13.7263 4.12439C13.5264 4.30726 13.4021 4.55834 13.378 4.82823V15.172C13.3903 15.4466 13.5109 15.7052 13.7133 15.8911C13.9158 16.077 14.1836 16.1753 14.4582 16.1644ZM14.0676 4.82823C14.0904 4.74194 14.1411 4.66563 14.2118 4.61118C14.2826 4.55673 14.3693 4.52721 14.4586 4.52721C14.5478 4.52721 14.6346 4.55673 14.7053 4.61118C14.776 4.66563 14.8267 4.74194 14.8496 4.82823V15.172C14.8267 15.2583 14.776 15.3346 14.7053 15.3891C14.6346 15.4435 14.5478 15.4731 14.4586 15.4731C14.3693 15.4731 14.2826 15.4435 14.2118 15.3891C14.1411 15.3346 14.0904 15.2583 14.0676 15.172V4.82823ZM18.9174 5.79158C18.6429 5.78054 18.3752 5.8786 18.1727 6.06434C17.9702 6.25008 17.8495 6.5084 17.8369 6.78287V13.196C17.8605 13.4663 17.9846 13.7179 18.1847 13.9011C18.3847 14.0844 18.6461 14.1861 18.9174 14.1861C19.1887 14.1861 19.4502 14.0844 19.6502 13.9011C19.8503 13.7179 19.9743 13.4663 19.998 13.196V6.78287C19.9854 6.5084 19.8647 6.25008 19.6622 6.06434C19.4597 5.8786 19.192 5.78054 18.9174 5.79158ZM19.3084 13.1967C19.2856 13.283 19.2349 13.3593 19.1642 13.4138C19.0934 13.4682 19.0067 13.4977 18.9174 13.4977C18.8282 13.4977 18.7414 13.4682 18.6707 13.4138C18.6 13.3593 18.5493 13.283 18.5264 13.1967V6.78355C18.5493 6.69727 18.6 6.62095 18.6707 6.56651C18.7414 6.51206 18.8282 6.48253 18.9174 6.48253C19.0067 6.48253 19.0934 6.51206 19.1642 6.56651C19.2349 6.62095 19.2856 6.69727 19.3084 6.78355V13.1967ZM1.08058 13.2922C1.35506 13.3033 1.62276 13.2052 1.82522 13.0196C2.02768 12.8339 2.14845 12.5757 2.16117 12.3013V7.469C2.14845 7.1946 2.02768 6.93637 1.82522 6.7507C1.62276 6.56504 1.35506 6.46702 1.08058 6.47807C0.806103 6.46702 0.538404 6.56504 0.335944 6.7507C0.133484 6.93637 0.0127116 7.1946 0 7.469V12.3013C0.0127116 12.5757 0.133484 12.8339 0.335944 13.0196C0.538404 13.2052 0.806103 13.3033 1.08058 13.2922ZM0.689587 7.469C0.704079 7.3784 0.75262 7.29676 0.825292 7.24075C0.897963 7.18474 0.98928 7.15859 1.08058 7.16765C1.17189 7.15859 1.2632 7.18474 1.33587 7.24075C1.40855 7.29676 1.45709 7.3784 1.47158 7.469V12.3013C1.45709 12.3919 1.40855 12.4735 1.33587 12.5295C1.2632 12.5855 1.17189 12.6117 1.08058 12.6026C0.98928 12.6117 0.897963 12.5855 0.825292 12.5295C0.75262 12.4735 0.704079 12.3919 0.689587 12.3013V7.469Z"
                fill="#373B53"
            />
        </svg>
    )
}

export const Notification = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                stroke="#C9CED6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
                stroke="#C9CED6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="18" cy="4" r="3" fill="#0094B6" />
        </svg>
    )
}

export const MenuIcon = () => {
    return (
        <svg className="w-8 h-8" viewBox="0 -0.5 25 25" fill="none">
            <path d="M5.5 7.75C5.08579 7.75 4.75 8.08579 4.75 8.5C4.75 8.91421 5.08579 9.25 5.5 9.25V7.75ZM19.5 9.25C19.9142 9.25 20.25 8.91421 20.25 8.5C20.25 8.08579 19.9142 7.75 19.5 7.75V9.25ZM5.5 11.75C5.08579 11.75 4.75 12.0858 4.75 12.5C4.75 12.9142 5.08579 13.25 5.5 13.25V11.75ZM17.5 13.25C17.9142 13.25 18.25 12.9142 18.25 12.5C18.25 12.0858 17.9142 11.75 17.5 11.75V13.25ZM5.5 15.75C5.08579 15.75 4.75 16.0858 4.75 16.5C4.75 16.9142 5.08579 17.25 5.5 17.25V15.75ZM12.5 17.25C12.9142 17.25 13.25 16.9142 13.25 16.5C13.25 16.0858 12.9142 15.75 12.5 15.75V17.25ZM5.5 9.25H19.5V7.75H5.5V9.25ZM5.5 13.25H17.5V11.75H5.5V13.25ZM5.5 17.25H12.5V15.75H5.5V17.25Z" fill="#000000" />
        </svg>
    )
}

export const LogOut = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
                stroke="#C9CED6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16 17L21 12L16 7"
                stroke="#C9CED6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21 12H9"
                stroke="#C9CED6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const Play = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="7"
            height="9"
            viewBox="0 0 7 9"
            fill="none"
            className='w-4 h-4 ml-2 ,t-1'
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.26323 8C1.11785 8 1 7.86091 1 7.68933V1.93261C0.999819 1.59953 1.15026 1.29165 1.39463 1.12502C1.63899 0.958382 1.94013 0.958325 2.18454 1.12487L5.60655 3.46421C5.8501 3.63095 6 3.93811 6 4.2704C6 4.6027 5.8501 4.90986 5.60655 5.07659L2.44777 7.25128C2.36617 7.3125 2.26271 7.316 2.17827 7.26039C2.09384 7.20477 2.04204 7.09901 2.04335 6.9849C2.04466 6.87079 2.09887 6.76672 2.18454 6.71382L5.34332 4.53913C5.4245 4.48355 5.47447 4.38117 5.47447 4.2704C5.47447 4.15964 5.4245 4.05725 5.34332 4.00167L1.92131 1.66233C1.8397 1.60672 1.73914 1.60684 1.65762 1.66263C1.57611 1.71843 1.52609 1.8214 1.52646 1.93261V7.68933C1.52646 7.86091 1.40861 8 1.26323 8Z"
                fill="#0094B6"
                stroke="#0094B6"
                strokeWidth="0.3"
            />
        </svg>
    )
}

export const Recorder = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="10"
            viewBox="0 0 14 10"
            fill="none"
            className='mt-0.5'
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.9099 10C4.95246 10 4.17631 9.21084 4.17631 8.23737V4.12456C4.17631 3.80007 3.91759 3.53701 3.59844 3.53701C3.44549 3.52329 3.29406 3.57675 3.18238 3.6839C3.08243 3.78258 3.02613 3.91827 3.02636 4.05993C3.02825 4.57959 2.81918 5.07701 2.44849 5.43478C2.07478 5.79037 1.57214 5.97137 1.06162 5.9342L0.541543 5.89894C0.222398 5.87785 -0.019504 5.5977 0.0012405 5.27321C0.021985 4.94872 0.29752 4.70276 0.616666 4.72385L1.13674 4.75911C1.32822 4.77231 1.51652 4.70424 1.65682 4.57109C1.79807 4.43767 1.87774 4.25008 1.87641 4.05405C1.8752 3.59329 2.05885 3.15194 2.38493 2.83196C2.71245 2.51706 3.14772 2.34425 3.59844 2.35018C4.55588 2.35018 5.33204 3.13933 5.33204 4.11281V8.22562C5.33204 8.55011 5.59076 8.81316 5.9099 8.81316C6.22905 8.81316 6.48777 8.55011 6.48777 8.22562V1.76263C6.48777 0.789157 7.26392 0 8.22136 0C9.17879 0 9.95495 0.789157 9.95495 1.76263V6.46298C9.95495 6.78748 10.2137 7.05053 10.5328 7.05053C10.852 7.05053 11.1107 6.78748 11.1107 6.46298C11.1107 5.48951 11.8868 4.70035 12.8443 4.70035H13.4221C13.7413 4.70035 14 4.9634 14 5.2879C14 5.61239 13.7413 5.87544 13.4221 5.87544H12.8443C12.5251 5.87544 12.2664 6.13849 12.2664 6.46298C12.2664 7.43646 11.4903 8.22562 10.5328 8.22562C9.57538 8.22562 8.79922 7.43646 8.79922 6.46298V1.76263C8.79922 1.43814 8.5405 1.17509 8.22136 1.17509C7.90221 1.17509 7.64349 1.43814 7.64349 1.76263V8.22562C7.64657 8.69513 7.46529 9.14648 7.13984 9.47959C6.81439 9.81269 6.37169 10 5.9099 10Z"
                fill="#0094B6"
            />
        </svg>
    )
}

export const Save = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="13"
            viewBox="0 0 15 13"
            fill="none"
            className=""
        >
            <path
                opacity="0.5"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.125 12.5H11.875C11.5298 12.5 11.25 12.2202 11.25 11.875C11.25 11.5298 11.5298 11.25 11.875 11.25H13.125C13.4702 11.25 13.75 10.9702 13.75 10.625V4.375C13.75 4.02982 13.4702 3.75 13.125 3.75H3.125C2.77982 3.75 2.5 3.47018 2.5 3.125C2.5 2.77982 2.77982 2.5 3.125 2.5H13.125C14.1605 2.5 15 3.33947 15 4.375V10.625C15 11.6605 14.1605 12.5 13.125 12.5ZM4.375 11.875C4.375 11.5298 4.09518 11.25 3.75 11.25H1.875C1.52982 11.25 1.25 10.9702 1.25 10.625V1.875C1.25 1.52982 1.52982 1.25 1.875 1.25H5.73125C5.89738 1.24904 6.05705 1.31426 6.175 1.43125L6.43125 1.6875C6.67922 1.89986 7.04887 1.88558 7.27973 1.65473C7.51058 1.42387 7.52486 1.05423 7.3125 0.80625L7.05625 0.55C6.70496 0.198269 6.22836 0.00043763 5.73125 0H1.875C0.839466 0 0 0.839466 0 1.875V10.625C0 11.6605 0.839466 12.5 1.875 12.5H3.75C4.09518 12.5 4.375 12.2202 4.375 11.875ZM7.94361 12.3188L10.4436 9.81875C10.656 9.57078 10.6417 9.20113 10.4108 8.97027C10.18 8.73942 9.81034 8.72514 9.56236 8.9375L8.13111 10.3687V5.625C8.13111 5.27982 7.85129 5 7.50611 5C7.16094 5 6.88111 5.27982 6.88111 5.625V11.875C6.87964 12.1289 7.03193 12.3585 7.26644 12.4559C7.50095 12.5532 7.77106 12.499 7.94986 12.3188H7.94361ZM6.06881 10.4438C6.31114 10.2 6.31114 9.80628 6.06881 9.56251L5.44381 8.93751C5.29107 8.75915 5.05124 8.68146 4.82292 8.73638C4.59461 8.7913 4.41635 8.96956 4.36143 9.19787C4.30651 9.42619 4.3842 9.66602 4.56256 9.81876L5.18756 10.4438C5.43133 10.6861 5.82504 10.6861 6.06881 10.4438Z"
                fill="#0F1E36"
            />
        </svg>
    )
}

export const Search = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className="absolute top-16 left-6"
        >
            <g clipPath="url(#clip0_599_1096)">
                <path
                    d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
                    fill="#C4C4C4"
                />
            </g>
            <defs>
                <clipPath id="clip0_599_1096">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const Share = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="12"
            viewBox="0 0 14 12"
            fill="#0094B6"
        >
            <path
                opacity="1"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.2471 12C11.4664 11.9991 10.7803 11.4096 10.5644 10.5541L4.06702 8.46197C3.34821 9.36392 2.18445 9.59494 1.24065 9.02302C0.296857 8.4511 -0.186485 7.22197 0.0667887 6.03791C0.320062 4.85385 1.24541 4.01657 2.31414 4.00444C2.91427 4.00359 3.49169 4.26602 3.92679 4.73737L7.89414 1.62576C8.05141 0.681892 8.77529 -0.000873401 9.6178 8.38595e-07C10.5859 8.38595e-07 11.3707 0.894934 11.3707 1.99889C11.3707 3.10285 10.5859 3.99778 9.6178 3.99778C9.29511 3.99778 9.03351 3.69947 9.03351 3.33148C9.03351 2.9635 9.29511 2.66519 9.6178 2.66519C9.92734 2.66063 10.18 2.38157 10.194 2.02891C10.2079 1.67626 9.9782 1.37243 9.67027 1.33617C9.36235 1.29992 9.08307 1.54382 9.03351 1.89228C8.97956 2.23432 8.80405 2.53573 8.54855 2.72515L4.13129 6.18323C3.99178 6.29207 3.81778 6.32668 3.6542 6.27813C3.49062 6.22957 3.3535 6.10262 3.27822 5.93004C2.99715 5.43371 2.46304 5.20769 1.96608 5.37477C1.46911 5.54186 1.12796 6.06214 1.12796 6.65297C1.12796 7.2438 1.46911 7.76409 1.96608 7.93117C2.46304 8.09825 2.99715 7.87223 3.27822 7.3759C3.40761 7.10118 3.68678 6.96553 3.95016 7.04942L10.8507 9.24153C11.2479 9.36919 11.5566 9.72629 11.6628 10.181C11.7466 10.5074 12.0325 10.7095 12.3261 10.6499C12.6197 10.5902 12.8268 10.2879 12.8066 9.9486C12.7863 9.60928 12.5451 9.34184 12.2471 9.32815C11.9244 9.32815 11.6628 9.02984 11.6628 8.66185C11.6628 8.29387 11.9244 7.99556 12.2471 7.99556C13.2152 7.99556 14 8.89049 14 9.99445C14 11.0984 13.2152 11.9933 12.2471 11.9933V12Z"
                fill="#0094B6"
            />
        </svg>
    )
}

export const Add = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 20 20"
            fill="none"
            className="mt-0.5"
        >
            <path
                d="M18.3374 11.1429H11.4803V18H9.19455V11.1429H2.3374V8.85714H9.19455V2H11.4803V8.85714H18.3374V11.1429Z"
                fill="white"
            />
        </svg>
    )
}

export const Clock = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                stroke="#4CB8FF"
                strokeWidth="2"
                strokeLinecap="square"
            />
            <path
                d="M12 5V12L16 16"
                stroke="#4CB8FF"
                strokeWidth="2"
                strokeLinecap="square"
            />
        </svg>
    )
}

export const DownArrow = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 24"
            fill="none"
            className="mt-0.5 ml-1"
        >
            <path
                d="M6.08472 9L11.2248 15L16.3649 9"
                stroke="#7D90B2"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const Download = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            className="mt-0.5"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.9138 8.34315L7.84988 14.7071C7.47777 15.0976 6.87445 15.0976 6.50234 14.7071L0.438435 8.34315C0.066323 7.95262 0.066323 7.31946 0.438435 6.92893C0.810547 6.53841 1.41386 6.53841 1.78597 6.92893L6.22326 11.5858L6.22326 -3.72354e-07L8.12896 -2.83317e-07L8.12896 11.5858L12.5663 6.92893C12.9384 6.53841 13.5417 6.53841 13.9138 6.92893C14.2859 7.31946 14.2859 7.95262 13.9138 8.34315Z"
                fill="#7D90B2"
            />
        </svg>
    )
}

export const Gear = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className="hover:text-white"
        >
            <g clipPath="url(#clip0_533_222)">
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke="#969CBA"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15V15Z"
                    stroke="#969CBA"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_533_222">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const Love = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M20.16 4.61006C19.0983 3.54806 17.6907 2.90238 16.1932 2.79044C14.6957 2.67849 13.2078 3.10772 12 4.00006C10.7277 3.0537 9.14399 2.62457 7.56792 2.7991C5.99185 2.97362 4.54044 3.73884 3.50597 4.94064C2.47151 6.14245 1.93082 7.69158 1.9928 9.27607C2.05478 10.8606 2.71482 12.3627 3.84 13.4801L11.29 20.9301C11.383 21.0238 11.4936 21.0982 11.6154 21.1489C11.7373 21.1997 11.868 21.2259 12 21.2259C12.132 21.2259 12.2627 21.1997 12.3846 21.1489C12.5064 21.0982 12.617 21.0238 12.71 20.9301L20.16 13.4801C20.7427 12.8978 21.2049 12.2064 21.5202 11.4454C21.8356 10.6844 21.9979 9.86879 21.9979 9.04506C21.9979 8.22133 21.8356 7.40567 21.5202 6.64469C21.2049 5.88371 20.7427 5.19233 20.16 4.61006ZM18.75 12.0701L12 18.8101L5.25 12.0701C4.65518 11.4728 4.24998 10.7131 4.08523 9.8864C3.92049 9.05969 4.00353 8.20274 4.32395 7.42305C4.64437 6.64336 5.1879 5.97565 5.88635 5.50368C6.58479 5.03171 7.40706 4.7765 8.25 4.77006C9.37611 4.77282 10.4551 5.22239 11.25 6.02006C11.343 6.11379 11.4536 6.18818 11.5754 6.23895C11.6973 6.28972 11.828 6.31586 11.96 6.31586C12.092 6.31586 12.2227 6.28972 12.3446 6.23895C12.4664 6.18818 12.577 6.11379 12.67 6.02006C13.4883 5.31094 14.5455 4.9392 15.6275 4.98008C16.7096 5.02096 17.7357 5.47141 18.4982 6.24025C19.2607 7.00909 19.7026 8.0389 19.7345 9.12125C19.7664 10.2036 19.3859 11.2576 18.67 12.0701H18.75Z"
                fill="#FFB800"
            />
        </svg>
    )
}

export const Mark = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M3 16L8 11"
                stroke="#21B8C7"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9 11C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11Z"
                stroke="#21B8C7"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14 16C14.5523 16 15 15.5523 15 15C15 14.4477 14.5523 14 14 14C13.4477 14 13 14.4477 13 15C13 15.5523 13.4477 16 14 16Z"
                stroke="#21B8C7"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15 14L21 8M10 11L13 14L10 11Z"
                stroke="#21B8C7"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const Music = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
        >
            <path
                d="M22.9582 18.125V4.83334C22.9574 4.65184 22.9157 4.47286 22.8362 4.3097C22.7567 4.14653 22.6415 4.00337 22.4991 3.89084C22.3587 3.77728 22.1947 3.69663 22.019 3.65481C21.8434 3.61299 21.6606 3.61106 21.4841 3.64917L10.6091 6.06584C10.3406 6.12638 10.1009 6.27676 9.92947 6.49209C9.75808 6.70742 9.66534 6.9748 9.66657 7.25001V17.3275C8.84168 16.9381 7.91276 16.8266 7.01916 17.0099C6.12556 17.1931 5.31546 17.6611 4.7104 18.3438C4.10534 19.0264 3.73794 19.8869 3.66331 20.796C3.58868 21.7051 3.81086 22.6139 4.2965 23.3861C4.78214 24.1583 5.50507 24.7522 6.35683 25.0787C7.20859 25.4052 8.14325 25.4467 9.0206 25.197C9.89796 24.9473 10.6707 24.4199 11.2229 23.6938C11.7751 22.9677 12.077 22.0822 12.0832 21.17C12.0957 20.9608 12.0957 20.7509 12.0832 20.5417V8.21667L20.5416 6.34376V14.9108C19.7162 14.5212 18.7867 14.4098 17.8927 14.5935C16.9986 14.7771 16.1883 15.2458 15.5834 15.9293C14.9784 16.6128 14.6116 17.474 14.5379 18.3838C14.4642 19.2935 14.6876 20.2026 15.1746 20.9745C15.6616 21.7464 16.3859 22.3395 17.2388 22.6647C18.0916 22.9898 19.0269 23.0295 19.9042 22.7778C20.7815 22.5261 21.5535 21.9966 22.1042 21.2687C22.6549 20.5408 22.9546 19.654 22.9582 18.7413C22.9697 18.536 22.9697 18.3303 22.9582 18.125ZM7.90241 22.9583C7.56187 22.9582 7.22836 22.8615 6.94056 22.6795C6.65277 22.4974 6.42251 22.2375 6.2765 21.9299C6.13049 21.6222 6.07473 21.2795 6.11568 20.9414C6.15663 20.6034 6.29261 20.2838 6.50785 20.02C6.72309 19.7561 7.00875 19.5586 7.33168 19.4506C7.65461 19.3425 8.00157 19.3282 8.33228 19.4094C8.663 19.4906 8.9639 19.6639 9.20008 19.9093C9.43625 20.1546 9.59801 20.4619 9.66657 20.7954C9.67845 20.916 9.67845 21.0374 9.66657 21.1579C9.66667 21.6292 9.48197 22.0817 9.15212 22.4184C8.82228 22.755 8.3736 22.9489 7.90241 22.9583ZM18.7774 20.5417C18.4333 20.5444 18.0956 20.449 17.8037 20.2669C17.5118 20.0847 17.2778 19.8233 17.129 19.513C16.9802 19.2028 16.9228 18.8566 16.9635 18.5149C17.0042 18.1733 17.1413 17.8503 17.3587 17.5836C17.5762 17.317 17.8651 17.1178 18.1916 17.0092C18.5181 16.9007 18.8688 16.8874 19.2026 16.9708C19.5364 17.0542 19.8396 17.2309 20.0767 17.4802C20.3138 17.7295 20.475 18.0412 20.5416 18.3788C20.5534 18.4993 20.5534 18.6207 20.5416 18.7413C20.5384 19.2178 20.3477 19.6739 20.0107 20.0108C19.6738 20.3478 19.2177 20.5385 18.7412 20.5417H18.7774Z"
                fill="#4CB8FF"
            />
        </svg>
    )
}

export const Person = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className=''
        >
            <path
                d="M3 21C3 17.625 7.5 17.625 9.75 15.375C10.875 14.25 7.5 14.25 7.5 8.625C7.5 4.87538 8.99962 3 12 3C15.0004 3 16.5 4.87538 16.5 8.625C16.5 14.25 13.125 14.25 14.25 15.375C16.5 17.625 21 17.625 21 21"
                stroke="#6F52ED"
                strokeWidth="2"
                strokeLinecap="square"
            />
        </svg>
    )
}

export const UnderPerform = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M3 7L9 13L13 9L20.405 16.405"
                stroke="#FF4C61"
                strokeWidth="2"
                strokeLinecap="square"
            />
            <path
                d="M20.405 16.405L21 17"
                stroke="#FF4C61"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M21 14V17H18"
                stroke="#FF4C61"
                strokeWidth="2"
                strokeLinecap="square"
            />
        </svg>
    )
}

export const Dollar = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 12 24"
            fill="none"
        >
            <path
                d="M8.20664 15.9962C8.20664 15.3533 8.0263 14.8437 7.66576 14.4675C7.31301 14.0833 6.70936 13.7305 5.85483 13.4091C5.0003 13.0876 4.26335 12.7701 3.64398 12.4566C3.02467 12.1352 2.49158 11.7707 2.04472 11.363C1.60569 10.9475 1.26075 10.4614 1.00989 9.90479C0.766858 9.34819 0.645337 8.68572 0.645337 7.91744C0.645337 6.59254 1.06868 5.50675 1.91536 4.66008C2.76205 3.8134 3.88708 3.3195 5.29029 3.17839V1.60262C5.29029 1.08305 5.71146 0.661865 6.2311 0.661865C6.75059 0.661865 7.17176 1.08305 7.17176 1.60262V3.21367C8.55939 3.40966 9.64526 3.98979 10.4292 4.95407C10.9565 5.59745 11.3066 6.37034 11.4791 7.2727C11.6262 8.04117 10.9708 8.6818 10.1884 8.6818H9.62331C8.84088 8.6818 8.26245 8.02536 8.00859 7.28531C7.91311 7.00707 7.7832 6.77093 7.61872 6.57687C7.23452 6.10648 6.71715 5.8713 6.06648 5.8713C5.4236 5.8713 4.92578 6.05553 4.57303 6.42399C4.22028 6.78461 4.04376 7.28635 4.04376 7.9292C4.04376 8.52502 4.21631 9.00323 4.56127 9.36391C4.90623 9.72445 5.54515 10.0929 6.47802 10.4692C7.41883 10.8456 8.19091 11.2022 8.7947 11.5393C9.39834 11.8686 9.90791 12.245 10.3234 12.6683C10.7389 13.0838 11.0564 13.5619 11.2758 14.1029C11.4954 14.636 11.6051 15.2592 11.6051 15.9727C11.6051 17.3055 11.1896 18.3872 10.3587 19.2182C9.52768 20.0493 8.38301 20.5393 6.92484 20.6882V22.0935C6.92484 22.6097 6.50636 23.0284 5.98998 23.0284C5.47375 23.0284 5.05512 22.6097 5.05512 22.0935V20.6999C3.44806 20.5275 2.2015 19.9592 1.31563 18.9948C0.710971 18.3253 0.314502 17.5054 0.126242 16.5348C-0.022735 15.7667 0.632842 15.1259 1.41524 15.1259H1.98039C2.76279 15.1259 3.34393 15.7844 3.61381 16.5188C3.72119 16.811 3.86838 17.0641 4.05552 17.278C4.50248 17.7718 5.1414 18.0188 5.97241 18.0188C6.66219 18.0188 7.20718 17.8386 7.60696 17.4779C8.00675 17.1094 8.20664 16.6155 8.20664 15.9962Z"
                fill="#2ED297"
            />
        </svg>
    )
}

export const DropDown = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="6"
            viewBox="0 0 10 6"
            fill="none"
        >
            <path
                d="M4.99998 6C4.82076 6 4.64156 5.92797 4.50493 5.78422L0.205142 1.25832C-0.0683806 0.970413 -0.0683806 0.503627 0.205142 0.21584C0.478554 -0.0719468 0.921935 -0.0719468 1.19548 0.21584L4.99998 4.22061L8.80451 0.21598C9.07803 -0.071807 9.52137 -0.071807 9.79476 0.21598C10.0684 0.503767 10.0684 0.970553 9.79476 1.25846L5.49504 5.78436C5.35834 5.92813 5.17914 6 4.99998 6Z"
                fill="#181C2F"
            />
        </svg>
    )
}

export const SalesDropDown = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 21 24"
            fill="none"
            // className="mt-1"
        >
            <path
                d="M5.13037 9L10.2608 15L15.3912 9"
                stroke="#6F809E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const Dot = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="5"
            height="5"
            viewBox="0 0 5 5"
            fill="none"
            className="ml-2"
        >
            <path
                opacity="0.4"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.30106 4.26314C3.46377 4.26314 4.40633 3.32058 4.40633 2.15788C4.40633 0.99517 3.46377 0.0526123 2.30106 0.0526123C1.13836 0.0526123 0.195801 0.99517 0.195801 2.15788C0.195801 3.32058 1.13836 4.26314 2.30106 4.26314Z"
                fill="#181C2F"
            />
        </svg>
    )
}

export const Emoji = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            className="cursor-pointer transition duration-300 hover:opacity-75"

        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.511719 10.9999C0.511719 5.21047 5.24856 0.473633 11.038 0.473633C16.8275 0.473633 21.5644 5.21047 21.5644 10.9999C21.5644 16.7894 16.8275 21.5263 11.038 21.5263C5.24856 21.5263 0.511719 16.7894 0.511719 10.9999ZM16.3011 8.36843C16.3011 7.52632 15.5642 6.78948 14.7221 6.78948C13.88 6.78948 13.1432 7.52632 13.1432 8.36843C13.1432 9.21053 13.88 9.94737 14.7221 9.94737C15.5642 9.94737 16.3011 9.21053 16.3011 8.36843ZM7.35326 6.78948C8.19536 6.78948 8.93221 7.52632 8.93221 8.36843C8.93221 9.21053 8.19536 9.94737 7.35326 9.94737C6.51115 9.94737 5.77431 9.21053 5.77431 8.36843C5.77431 7.52632 6.51115 6.78948 7.35326 6.78948ZM5.14261 13.1052C5.98471 15.5263 8.3005 17.3158 11.0373 17.3158C13.7742 17.3158 16.09 15.5263 16.9321 13.1052H5.14261Z"
                fill="#0094B6"
            />
        </svg>
    )
}

export const Facebook = () => {
    return (
        <svg className="cursor-pointer transition duration-300 hover:opacity-75" width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M21.0745 41.3722C32.3793 41.3722 41.5436 32.2079 41.5436 20.9031C41.5436 9.59839 32.3793 0.434082 21.0745 0.434082C9.76977 0.434082 0.605469 9.59839 0.605469 20.9031C0.605469 32.2079 9.76977 41.3722 21.0745 41.3722Z" fill="#3D5A96" />
            <path fillRule="evenodd" clipRule="evenodd" d="M22.1504 29.9095H18.1575V21.4037H16.1621V18.1259H18.1575V16.1596C18.1575 13.4876 19.2841 11.8967 22.485 11.8967H25.1495V15.1745H23.4847C22.2383 15.1745 22.1554 15.632 22.1554 16.487L22.1504 18.1259H25.1685L24.8149 21.4037H22.1504V29.9095Z" fill="white" />
        </svg>
    )
}

export const Twitter = () => {
    return (
        <svg className="cursor-pointer transition duration-300 hover:opacity-75" width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M20.5755 41.3722C31.8802 41.3722 41.0445 32.2079 41.0445 20.9031C41.0445 9.59839 31.8802 0.434082 20.5755 0.434082C9.27075 0.434082 0.106445 9.59839 0.106445 20.9031C0.106445 32.2079 9.27075 41.3722 20.5755 41.3722Z" fill="#2AA3EF" />
            <path fillRule="evenodd" clipRule="evenodd" d="M29.5816 15.2787C28.9193 15.5746 28.2061 15.7746 27.459 15.8651C28.222 15.404 28.808 14.6755 29.0836 13.807C28.3693 14.2333 27.5788 14.5429 26.7363 14.7092C26.0623 13.9859 25.1023 13.5343 24.0394 13.5343C21.9984 13.5343 20.3432 15.1998 20.3432 17.2548C20.3432 17.5475 20.3771 17.8307 20.4396 18.1033C17.3686 17.9486 14.6462 16.4663 12.8235 14.2154C12.5046 14.765 12.3234 15.404 12.3234 16.0862C12.3234 17.3769 12.9761 18.516 13.9669 19.1824C13.3608 19.1635 12.7907 18.9961 12.2937 18.7171C12.2937 18.7329 12.2937 18.7487 12.2937 18.7645C12.2937 20.5668 13.5664 22.0702 15.2577 22.4123C14.9472 22.4976 14.6218 22.5428 14.2838 22.5428C14.0464 22.5428 13.8143 22.5197 13.5886 22.4755C14.0591 23.9536 15.424 25.0295 17.0411 25.06C15.7759 26.057 14.1821 26.6518 12.4505 26.6518C12.1527 26.6518 11.8581 26.635 11.5688 26.6002C13.204 27.6561 15.1464 28.272 17.234 28.272C24.0309 28.272 27.7483 22.6029 27.7483 17.6864C27.7483 17.5243 27.7441 17.3653 27.7377 17.2053C28.4594 16.681 29.0867 16.0252 29.5816 15.2798V15.2787Z" fill="white" />
        </svg>
    )
}

export const Instagram = () => {
    return (
        <svg className="cursor-pointer transition duration-300 hover:opacity-75" width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M21.0765 41.3722C32.3812 41.3722 41.5455 32.2079 41.5455 20.9031C41.5455 9.59839 32.3812 0.434082 21.0765 0.434082C9.77173 0.434082 0.607422 9.59839 0.607422 20.9031C0.607422 32.2079 9.77173 41.3722 21.0765 41.3722Z" fill="url(#paint0_linear_636_212)" />
            <path fillRule="evenodd" clipRule="evenodd" d="M25.3787 10.2593H16.7744C13.2775 10.2593 10.4326 13.1042 10.4326 16.601V25.2053C10.4326 28.7022 13.2775 31.5471 16.7744 31.5471H25.3787C28.8755 31.5471 31.7204 28.7022 31.7204 25.2053V16.601C31.7204 13.1042 28.8755 10.2593 25.3787 10.2593ZM29.5788 25.2052C29.5788 27.5249 27.6983 29.4054 25.3786 29.4054H16.7743C14.4546 29.4054 12.5741 27.5249 12.5741 25.2052V16.6009C12.5741 14.2812 14.4546 12.4007 16.7743 12.4007H25.3786C27.6983 12.4007 29.5788 14.2812 29.5788 16.6009V25.2052ZM15.5702 20.903C15.5702 17.8672 18.0401 15.3973 21.076 15.3973C24.1119 15.3973 26.5818 17.8671 26.5818 20.903C26.5818 23.9389 24.1119 26.4088 21.076 26.4088C18.0401 26.4088 15.5702 23.9389 15.5702 20.903ZM21.0767 24.2673C19.2187 24.2673 17.7125 22.7611 17.7125 20.9031C17.7125 19.045 19.2187 17.5388 21.0767 17.5388C22.9347 17.5388 24.4409 19.045 24.4409 20.9031C24.4409 22.7611 22.9347 24.2673 21.0767 24.2673ZM27.9123 15.4386C27.9123 16.1673 27.3217 16.7579 26.593 16.7579C25.8644 16.7579 25.2737 16.1673 25.2737 15.4386C25.2737 14.71 25.8644 14.1193 26.593 14.1193C27.3217 14.1193 27.9123 14.71 27.9123 15.4386Z" fill="white" />
            <defs>
                <linearGradient id="paint0_linear_636_212" x1="0.744197" y1="0.365695" x2="0.607423" y2="41.3038" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#7024C4" />
                    <stop offset="0.415461" stopColor="#C21975" />
                    <stop offset="0.702206" stopColor="#C74C4D" />
                    <stop offset="1" stopColor="#E09B3D" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const Link = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="21"
            viewBox="0 0 22 21"
            fill="none"
            className="cursor-pointer transition duration-300 hover:opacity-75"
        >
            <path
                opacity="0.3"
                d="M1.23118 18.9554C2.87192 20.628 5.54177 20.6297 7.1833 18.9554L16.7061 9.2483C17.1845 8.76563 17.4492 8.11788 17.4508 7.42819C17.4549 6.04973 16.2721 4.84471 14.9199 4.84809C14.2435 4.84975 13.6088 5.11962 13.1321 5.61066L4.80195 14.1018C4.47315 14.438 4.47315 14.98 4.80195 15.3152C5.13074 15.6504 5.6634 15.6504 5.9922 15.3152L14.3248 6.82067C14.4867 6.65474 14.698 6.56507 14.9241 6.56426C15.3746 6.56426 15.7674 6.96483 15.7674 7.42401C15.7666 7.65446 15.6786 7.86984 15.5184 8.03154L5.9922 17.742C5.00827 18.7476 3.4062 18.7476 2.42144 17.742C1.43667 16.7398 1.43667 15.1058 2.42144 14.1018L13.1346 3.18051C14.7753 1.50788 17.4459 1.50788 19.0867 3.18051C20.7274 4.85313 20.7274 7.57568 19.0867 9.2483L10.754 17.742C10.4252 18.0772 10.4252 18.6202 10.754 18.9554C11.0828 19.2906 11.6155 19.2906 11.9443 18.9554L20.2769 10.4617C22.5744 8.11954 22.5744 4.30851 20.2769 1.96712C17.9802 -0.375026 14.2418 -0.375026 11.9443 1.96712L1.23118 12.8885C-0.410394 14.5619 -0.410394 17.2828 1.23118 18.9554Z"
                fill="#292F4C"
            />
            <mask
                id="mask0_636_11"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="22"
                height="21"
            >
                <path
                    d="M1.23118 18.9554C2.87192 20.628 5.54177 20.6297 7.1833 18.9554L16.7061 9.2483C17.1845 8.76563 17.4492 8.11788 17.4508 7.42819C17.4549 6.04973 16.2721 4.84471 14.9199 4.84809C14.2435 4.84975 13.6088 5.11962 13.1321 5.61066L4.80195 14.1018C4.47315 14.438 4.47315 14.98 4.80195 15.3152C5.13074 15.6504 5.6634 15.6504 5.9922 15.3152L14.3248 6.82067C14.4867 6.65474 14.698 6.56507 14.9241 6.56426C15.3746 6.56426 15.7674 6.96483 15.7674 7.42401C15.7666 7.65446 15.6786 7.86984 15.5184 8.03154L5.9922 17.742C5.00827 18.7476 3.4062 18.7476 2.42144 17.742C1.43667 16.7398 1.43667 15.1058 2.42144 14.1018L13.1346 3.18051C14.7753 1.50788 17.4459 1.50788 19.0867 3.18051C20.7274 4.85313 20.7274 7.57568 19.0867 9.2483L10.754 17.742C10.4252 18.0772 10.4252 18.6202 10.754 18.9554C11.0828 19.2906 11.6155 19.2906 11.9443 18.9554L20.2769 10.4617C22.5744 8.11954 22.5744 4.30851 20.2769 1.96712C17.9802 -0.375026 14.2418 -0.375026 11.9443 1.96712L1.23118 12.8885C-0.410394 14.5619 -0.410394 17.2828 1.23118 18.9554Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0_636_11)"></g>
        </svg>
    )
}

export const Options = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="7"
            viewBox="0 0 29 7"
            className='cursor-pointer'
            fill="none"
        >
            <g opacity="0.3">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.985 6.94738C26.7291 6.94738 28.1429 5.53354 28.1429 3.78949C28.1429 2.04543 26.7291 0.631592 24.985 0.631592C23.241 0.631592 21.8271 2.04543 21.8271 3.78949C21.8271 5.53354 23.241 6.94738 24.985 6.94738Z"
                    fill="#292F4C"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.4587 6.94738C16.2027 6.94738 17.6166 5.53354 17.6166 3.78949C17.6166 2.04543 16.2027 0.631592 14.4587 0.631592C12.7146 0.631592 11.3008 2.04543 11.3008 3.78949C11.3008 5.53354 12.7146 6.94738 14.4587 6.94738Z"
                    fill="#292F4C"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.9328 6.94738C5.67685 6.94738 7.09069 5.53354 7.09069 3.78949C7.09069 2.04543 5.67685 0.631592 3.9328 0.631592C2.18874 0.631592 0.774902 2.04543 0.774902 3.78949C0.774902 5.53354 2.18874 6.94738 3.9328 6.94738Z"
                    fill="#292F4C"
                />
            </g>
        </svg>
    )
}

export const Send = () => {
    return (
        <svg className="bg-[#0094B6] rounded-full w-10 h-10 p-2.5 cursor-pointer transition duration-300 hover:opacity-75" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.4932 0.68334C23.3893 0.593803 23.2414 0.57303 23.116 0.630139L0.467079 10.9668C0.345144 11.0225 0.266623 11.1419 0.265158 11.274C0.263692 11.406 0.33963 11.5272 0.460378 11.5854L6.87 14.6752C6.98753 14.7319 7.12768 14.719 7.23266 14.642L13.4646 10.0668L8.57226 15.0099C8.50246 15.0804 8.46687 15.177 8.47455 15.275L8.96166 21.5062C8.97247 21.6443 9.0667 21.7624 9.20064 21.8056C9.23644 21.8171 9.27323 21.8228 9.30959 21.8228C9.40933 21.8228 9.50635 21.7807 9.57384 21.7039L12.9759 17.8316L17.1814 19.8054C17.2727 19.8483 17.3784 19.8501 17.4712 19.8104C17.5639 19.7707 17.6346 19.6935 17.6649 19.5988L23.596 1.04375C23.6375 0.914175 23.5971 0.772877 23.4932 0.68334Z" fill="white" />
        </svg>
    )
}

export const Phone = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            className='cursor-pointer'
            fill="none"
        >
            <g opacity="0.3">
                <path
                    d="M17.4518 13.7934L17.3661 13.5408C17.163 12.9506 16.4973 12.335 15.8857 12.1728L13.6223 11.5682C13.0085 11.405 12.133 11.6245 11.6839 12.0636L10.8647 12.8645C7.8877 12.078 5.55325 9.79533 4.7499 6.88503L5.5691 6.08404C6.01818 5.64493 6.24269 4.78996 6.0757 4.1898L5.45851 1.97561C5.29152 1.37655 4.66079 0.725662 4.0583 0.529269L3.79992 0.444329C3.19627 0.247937 2.33537 0.446554 1.88632 0.885621L0.660967 2.08484C0.442058 2.29775 0.302149 2.90674 0.302149 2.90896C0.259291 6.7129 1.78476 10.3778 4.53666 13.0686C7.28181 15.7527 11.016 17.2421 14.8951 17.2101C14.9153 17.2101 15.5562 17.0755 15.7751 16.8626L17.0005 15.6644C17.4495 15.2254 17.6526 14.3837 17.4518 13.7934Z"
                    fill="#292F4C"
                />
            </g>
        </svg>
    )
}

export const Offline = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            className="absolute top-0"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                fill="white"
            />
            <path
                opacity="0.2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z"
                fill="#181C2F"
            />
        </svg>
    )
}

export const Online = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            className="absolute top-0"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z"
                fill="#34D859"
            />
        </svg>
    )
}

export const ForwardIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="14"
            viewBox="0 0 16 14"
            fill="gray"
        >
            <path
                opacity="0.4"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.8304 4.65218C13.9435 4.76296 14 4.89408 14 5.04575C14 5.19739 13.9435 5.32842 13.8304 5.4392L10.2856 8.91076V9.52286C10.2856 9.76782 10.4018 9.93962 10.634 10.0388C10.7113 10.0679 10.7857 10.0825 10.8571 10.0825C11.0179 10.0825 11.1519 10.0271 11.259 9.91634L15.8304 5.43923C15.9434 5.32842 16 5.19733 16 5.04575C16 4.89417 15.9434 4.76305 15.8304 4.65218L11.259 0.17504C11.0864 -0.00569609 10.8781 -0.0463701 10.6341 0.0525584C10.4019 0.151732 10.2858 0.323677 10.2858 0.568518V1.17192L13.8304 4.65218ZM6.85739 2.85955C4.41093 3.0228 2.62819 3.66688 1.5092 4.792C0.503139 5.80061 0.000156403 7.28414 0 9.24292C0 9.58096 0.0506296 9.97003 0.151765 10.4103C0.252993 10.8505 0.367513 11.2527 0.49551 11.617C0.623507 11.9814 0.766578 12.3456 0.924222 12.7101C1.08196 13.0745 1.20248 13.3383 1.28573 13.5016L1.46426 13.8514C1.51198 13.9504 1.59523 14 1.71425 14C1.74997 14 1.77674 13.9972 1.79459 13.9913C1.94345 13.9447 2.01171 13.8456 1.99996 13.694C1.74399 11.3619 2.0595 9.7152 2.94644 8.75333C3.32743 8.33939 3.8348 8.01734 4.46869 7.78705C5.10286 7.55679 5.89889 7.40377 6.85714 7.32797V9.52286C6.85714 9.76782 6.97335 9.93962 7.20548 10.0388C7.28288 10.0679 7.35725 10.0825 7.42864 10.0825C7.58938 10.0825 7.72316 10.0271 7.83049 9.91634L12.4018 5.43923C12.5149 5.32842 12.5714 5.19733 12.5714 5.04575C12.5714 4.8942 12.515 4.76308 12.4018 4.65218L7.83061 0.17504C7.65802 -0.00569609 7.44965 -0.0463701 7.20564 0.0525584C6.9735 0.151732 6.85739 0.323677 6.85739 0.568518V2.85955Z"
                fill="Gray"
            />
        </svg>
    )
}

export const Audio = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="26"
            viewBox="0 0 17 26"
            fill="none"
            className="cursor-pointer transition duration-300 hover:opacity-75"

        >
            <path
                opacity="0.3"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.25146 11.8515V4.30843C4.25146 2.89178 5.09081 1.65404 6.35614 0.94541V4.10798C6.35614 4.48136 6.7001 4.78787 7.12608 4.78787C7.55268 4.78787 7.89541 4.4819 7.89541 4.10798V0.394147C8.18065 0.346651 8.47274 0.315735 8.77423 0.315735C9.07386 0.315735 9.36657 0.346651 9.65182 0.394147V4.10792C9.65182 4.48129 9.99647 4.7878 10.4237 4.7878C10.849 4.7878 11.1936 4.48183 11.1936 4.10792V0.945342C12.4546 1.65397 13.2984 2.89171 13.2984 4.30843V11.8515C13.2984 14.0586 11.2706 15.847 8.77369 15.847C6.27488 15.847 4.25146 14.0586 4.25146 11.8515ZM1.47531 24.2351H2.52734L7.23278 22.8195V18.3435C3.83645 17.7149 1.27509 15.0483 1.27509 11.8614C1.27509 11.4367 1.66414 11.0931 2.14575 11.0931C2.27279 11.0931 2.39599 11.1185 2.50356 11.1611C2.80812 11.2831 3.02142 11.5493 3.02142 11.8614C3.02142 14.6639 5.60025 16.9422 8.77389 16.9422C11.9463 16.9422 14.5289 14.6639 14.5289 11.8614C14.5289 11.5499 14.741 11.2831 15.0431 11.1611C15.1526 11.1185 15.2739 11.0931 15.4009 11.0931C15.8844 11.0931 16.2753 11.4367 16.2753 11.8614C16.2753 15.0478 13.7146 17.7144 10.3139 18.3435V22.8189L15.0231 24.2351H16.0752C16.4048 24.2351 16.6694 24.4715 16.6694 24.7609V25.052C16.6694 25.3431 16.4048 25.5789 16.0752 25.5789H1.47531C1.14574 25.5789 0.879883 25.3431 0.879883 25.052V24.7609C0.879883 24.4715 1.14566 24.2351 1.47531 24.2351Z"
                fill="#292F4C"
            />
        </svg>
    )
}

export const ChatPlayIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="43"
            height="43"
            viewBox="0 0 43 43"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.933 42.3683C33.5601 42.3683 42.9856 32.9427 42.9856 21.3157C42.9856 9.68865 33.5601 0.263062 21.933 0.263062C10.306 0.263062 0.880371 9.68865 0.880371 21.3157C0.880371 32.9427 10.306 42.3683 21.933 42.3683Z"
                fill="#0094B6"
            />
            <path
                d="M28.9707 20.2167L18.5277 13.7129C18.2189 13.5312 17.8356 13.5615 17.546 13.5615C16.3879 13.5615 16.3931 14.4453 16.3931 14.6692V27.9624C16.3931 28.1517 16.388 29.0702 17.546 29.0702C17.8356 29.0702 18.219 29.1003 18.5277 28.9187L28.9706 22.4149C29.8278 21.9107 29.6797 21.3158 29.6797 21.3158C29.6797 21.3158 29.8279 20.7208 28.9707 20.2167Z"
                fill="white"
            />
        </svg>
    )
}

export const Video = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="16"
            viewBox="0 0 26 16"
            className='cursor-pointer'
            fill="none"
        >
            <g opacity="0.3">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.11754 0.421021H14.6435C16.1637 0.421021 17.4075 1.62851 17.4075 3.16531V12.4136C17.4075 13.9229 16.1637 15.1579 14.6435 15.1579H3.11754C1.59733 15.1579 0.353516 13.9229 0.353516 12.4136V3.16531C0.353516 1.65595 1.59733 0.421021 3.11754 0.421021ZM23.102 2.12247C23.2402 2.04014 23.406 1.95781 23.5719 1.93037C24.6498 1.68338 25.6172 2.50667 25.6172 3.52205V12.0019C25.6172 12.3038 25.5343 12.5782 25.3961 12.8252C24.9262 13.621 23.9312 13.8955 23.1296 13.4289L18.7901 10.9591V4.59233L23.102 2.12247Z"
                    fill="#292F4C"
                />
            </g>
        </svg>
    )
}

export const Chart = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="#0094B6"
            className="mr-4"
        >
            <path
                d="M2 12V21H6V12H2Z"
                fill="#0094B6"
                stroke="#0094B6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18 7V21H22V7H18Z"
                fill="#0094B6"
                stroke="#0094B6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 3V21H14V3H10Z"
                fill="#0094B6"
                stroke="#0094B6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const Chat = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="24"
            viewBox="0 0 22 24"
            fill="#0094B6"
            className="mr-4"
        >
            <path
                d="M19 1H3C1.9 1 1 1.9 1 3V21L5 17H19C20.1 17 21 16.1 21 15V3C21 1.9 20.1 1 19 1Z"
                fill="#0094B6"
                stroke="#0094B6"
                strokeWidth="2"
            />
        </svg>
    )
}

export const File = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="#0094B6"
            className="mr-4"
        >
            <path
                d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z"
                fill="#0094B6"
                fillOpacity="0.2"
                stroke="#0094B6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13 2V9H20"
                stroke="#0094B6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const CircleWhite = ()=> {
    return (
        <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="6" cy="5.5" r="5.5" fill="#F8F8FB" />
        </svg>
    )
}

export const CircleBlue = ()=> {
    return (
         <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="5.5" cy="5.5" r="5.5" fill="#0094B6" />
        </svg>
       
    )
}

export const Home = ({ isActive }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 22 20"
            fill={isActive ? "#FF0000" : "#000000"}
            className="mr-4 text-red-500"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.8785 9.07895L10.9393 0L0 9.07895H2.51822V20H19.3603V9.07895H21.8785Z"
                fill={isActive ? "#FF0000" : "#000000"} 
                stroke={isActive ? "#FF0000" : "#000000"} 
            />
        </svg>
    )
}

